import React from "react";
import { ExInput, Textarea } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { Box, Modal } from "@mui/material";
import Button from "../../extras/Button";


const SalonRequestDialogue = () => {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);

  console.log('dialogueData', dialogueData)

  return (
    <Modal
      open={true}
      onClose={closeDialog}
    >
      <Box className="model-style">
        <div className="model-header">
          <p className="m-0">Salon request details</p>
        </div>

       <div className="model-body">
          <div className="row align-items-start formBody">
            <div className="col-6">
              <ExInput
                value={dialogueData?.mobile}
                label={`Mobile`}
                placeholder={`Details`}
                readOnly={true}
              />
            </div>

            <div className="col-6">
              <ExInput
                value={dialogueData?.expertCount}
                label={`Expert count`}
                placeholder={`Details`}
                readOnly={true}
              />
            </div>
            {/* <div className="col-12 col-md-6">
                  <ExInput
                    type={`text`}
                    value={
                      dialogueData?.userId?.fname
                        ? dialogueData?.userId.fname +
                          " " +
                          dialogueData?.userId?.lname
                        : "-"
                    }
                    label={
                      dialogueData?.expertId
                        ? "Expert"
                        : dialogueData.userId
                        ? "User"
                        : ""
                    }
                    placeholder={
                      dialogueData?.expertId
                        ? "Expert"
                        : dialogueData.userId
                        ? "User"
                        : ""
                    }
                    readOnly={true}
                  />
                </div> */}


            <div className="col-12">
              <Textarea
                value={dialogueData?.about}
                label={`Details`}
                placeholder={`Details`}
                readOnly={true}
                row={4}
              />
            </div>
            <div className="col-12">
              <Textarea
                value={dialogueData?.address}
                label={`Address`}
                placeholder={`Details`}
                readOnly={true}
                row={4}
              />
            </div>


            {dialogueData?.image ? (
              <div className="col-6">
                <label className="d-block">Image</label>
                <img
                  src={dialogueData?.image ? dialogueData?.image : 'image not found'}
                  alt=""
                  draggable="false"
                  className="rounded-2"
                  data-class={`showImage`}
                  style={{
                    width: "100px",
                    height: "100px",
                    marginTop: "5px",
                  }}
                />
              </div>
            ) : null}
          </div>
      </div>

      <div className="model-footer">
                  <div className="m-3 d-flex justify-content-end gap-2">
                    <Button
                      className={`close-model-btn`}
                      text={`Cancel`}
                      type={`button`}
                      onClick={() => dispatch(closeDialog())}
                    />
                    
                  </div>
                </div>
      </Box>

    </Modal>


  );
};

export default SalonRequestDialogue;
